/**
 * @module features/clients/components/ClientStatsBanner
 * @description Alias and re-export for ClientStatsCards to preserve backward compatibility.
 */
export { ClientStatsCards as ClientStatsBanner } from "./ClientStatsCards";
export type { ClientStatsCardsProps as ClientStatsBannerProps } from "./ClientStatsCards";
